import { samplePath, classifyPathSamples, leadInDistance } from "./geometry";

// Editor for a walk-path. Coverage is geometrically bidirectional, but the
// activation experience is directional: enter a cone late and you walk a "dark
// lead-in" before the light fires. We surface the lead-in distance per travel
// direction so under-covered halls can be sacrificed deliberately.
function PathEditor({ path, roomName, nodes, onUpdate, onReverse, onDelete, onDeselect }) {
  const pts = path.points || [];
  const bidirectional = path.bidirectional !== false; // default on
  const samples = samplePath(pts, 0.2);
  const { covered } = classifyPathSamples(samples, nodes, bidirectional);
  const coveredCount = covered.filter(Boolean).length;
  const coveragePct = samples.length ? Math.round((coveredCount / samples.length) * 100) : 0;

  const fwdLead = leadInDistance(samples, covered, true);
  const revLead = leadInDistance(samples, covered, false);

  const fmtLead = (d) => {
    if (d === null) return "never detected";
    if (d === 0) return "lit immediately";
    return `dark for ${d.toFixed(1)} m`;
  };

  return (
    <div className="room-editor">
      <div className="room-editor-header">
        <h3>Walk-path</h3>
        <button className="btn-icon" onClick={onDeselect} title="Deselect">
          ✕
        </button>
      </div>

      <div className="room-editor-field">
        <label>Room</label>
        <div className="readonly-field">{roomName || "— (outside rooms)"}</div>
      </div>

      <div className="dim-row">
        <div className="dim-field">
          <label>Points</label>
          <div className="readonly-field">{pts.length}</div>
        </div>
        <div className="dim-field">
          <label>Coverage</label>
          <div className="readonly-field">{coveragePct}%</div>
        </div>
      </div>

      <label className="toolbar-toggle path-toggle">
        <input
          type="checkbox"
          checked={bidirectional}
          onChange={(e) => onUpdate({ bidirectional: e.target.checked })}
        />
        Walked both directions
      </label>

      <div className="node-section">
        <div className="node-section-head">
          <span>Lead-in (dark before first detection)</span>
        </div>
        <div className="lead-in-row">
          <span className="lead-in-dir">→ Forward</span>
          <span className={`lead-in-val ${fwdLead ? "lead-in-warn" : ""}`}>{fmtLead(fwdLead)}</span>
        </div>
        {bidirectional && (
          <div className="lead-in-row">
            <span className="lead-in-dir">← Reverse</span>
            <span className={`lead-in-val ${revLead ? "lead-in-warn" : ""}`}>{fmtLead(revLead)}</span>
          </div>
        )}
        <button className="btn-mini" onClick={onReverse} style={{ marginTop: "0.4rem" }}>
          ↔ Reverse direction
        </button>
      </div>

      <p className="editor-hint">
        <span className="legend-swatch" style={{ background: "#2ecc71" }} /> covered&nbsp;&nbsp;
        <span className="legend-swatch" style={{ background: "#f0a030" }} /> lead-in&nbsp;&nbsp;
        <span className="legend-swatch" style={{ background: "#e74c3c" }} /> blind
      </p>

      <div className="room-editor-actions">
        <button className="btn-secondary btn-danger" onClick={onDelete}>
          Delete Path
        </button>
      </div>
    </div>
  );
}

export default PathEditor;
